import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconQuality from 'components/icons/iconQuality';
import NotificationBannerSkeleton from './NotificationBannerSkeleton';
const ForgotPassword = t0 => {
  const $ = _c(4);
  const {
    email,
    onClose,
    isSuccess
  } = t0;
  let t1;
  if ($[0] !== email || $[1] !== isSuccess || $[2] !== onClose) {
    t1 = isSuccess ? <NotificationBannerSkeleton title="Your password is reset successfully." body="Please login again to proceed." icon={<IconQuality color="#27919C" style={{
      width: 24,
      height: 24
    }} />} onClose={onClose} /> : <NotificationBannerSkeleton title={`A link to reset your password has been sent to ${email}.`} body="This link will expire in the next 48 hours." icon={<IconQuality color="#27919C" style={{
      width: 24,
      height: 24
    }} />} onClose={onClose} />;
    $[0] = email;
    $[1] = isSuccess;
    $[2] = onClose;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
ForgotPassword.propTypes = {
  email: PropTypes.string,
  onClose: PropTypes.func,
  isSuccess: PropTypes.bool
};
export default ForgotPassword;